import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BcSharedModule } from '../bc-shared/bc-shared.module';
import { SpinnerComponent } from './spinner/spinner.component';
import { InputSelectComponent } from './input-select/input-select.component';
import { FooterComponent } from './footer/footer.component';
import { MenuComponent } from './header/menu.component';
import { MatSharedModule } from '../mat-shared/mat-shared.module';
import { CapitalizePipe } from '../pipes/capitalize/capitalize.pipe';
import { ClockDownComponent } from './clock-down/clock-down.component';
import { ErrorModalComponent } from './error-modal/error-modal.component';
import { ThousandsPipe } from '../pipes/thousandsPipe/thousandsPipe.pipe';
import { ViewPdfComponent } from './view-pdf/view-pdf.component';
import { PdfViewerModule } from 'ng2-pdf-viewer'
import { ValidateOtpComponent } from './validate-otp/validate-otp.component';
import { PolicyFinishComponent } from './policy-finish/policy-finish.component';
import { LogOutComponent } from './log-out/log-out.component';
import { CensureEmailPipe } from '../pipes/censure/censureEmailPipe.pipe';
import { PipesModule } from '../pipes/pipes.module';
import { BlockModuleComponent } from './block-module/block-module/block-module.component';

@NgModule({
  declarations: [
    SpinnerComponent,
    FooterComponent,
    MenuComponent,
    InputSelectComponent,
    ClockDownComponent,
    ErrorModalComponent,
    ViewPdfComponent,
    ValidateOtpComponent,
    PolicyFinishComponent,
    LogOutComponent,
    BlockModuleComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BcSharedModule,
    MatSharedModule,
    PdfViewerModule,
    PipesModule
  ],
  exports: [
    CommonModule,
    SpinnerComponent,
    MenuComponent,
    FooterComponent,
    InputSelectComponent,
    ClockDownComponent,
    ErrorModalComponent,
    ViewPdfComponent,
    ValidateOtpComponent,
    PolicyFinishComponent,
    LogOutComponent,
    PipesModule,
    BlockModuleComponent
  ],
  providers:[
    CapitalizePipe,
    ThousandsPipe,
    CensureEmailPipe
],
schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CommonsModule { }
